<mat-card appearance="outlined">
  <mat-form-field appearance="outline" class="cf-fill">
    <mat-label>Name</mat-label>
    <input type="text" [formControl]="name" matInput placeholder="object name" />
  </mat-form-field>
  <mat-card-subtitle>Id: {{ v3dObject.id }}</mat-card-subtitle>
</mat-card>
<mat-accordion multi="true">
  <mat-expansion-panel
    *ngFor="let component of v3dObject.components; trackBy: trackByFn; first as isFirst"
    [ngSwitch]="component.type"
    (opened)="(true)"
    [expanded]="isFirst"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ component.type }}
      </mat-panel-title>
      <button
        mat-icon-button
        [style.visibility]="component.type === 'Transform' ? 'hidden' : 'visible'"
        (click)="removeComponent(component.type); $event.stopPropagation()"
      >
        <mat-icon aria-hidden="false" aria-label="refresh">delete_forever</mat-icon>
      </button>
    </mat-expansion-panel-header>
    <ng-template ngSwitchCase="Transform">
      <app-transform-component-editor [component]="component" (componentChange)="onComponentChange()"></app-transform-component-editor>
    </ng-template>
    <ng-template ngSwitchCase="QModel">
      <app-q-model-component-editor [component]="component" (componentChange)="onComponentChange()"></app-q-model-component-editor>
    </ng-template>
    <ng-template ngSwitchCase="AmbientLight">
      <app-ambient-light-editor [component]="component" (componentChange)="onComponentChange()"></app-ambient-light-editor>
    </ng-template>
    <ng-template ngSwitchCase="SpotLight">
      <app-spot-light-editor [component]="component" (componentChange)="onComponentChange()"></app-spot-light-editor>
    </ng-template>
    <ng-template ngSwitchDefault>
      <app-unknown-component-editor [component]="component" (componentChange)="onComponentChange()"></app-unknown-component-editor>
    </ng-template>
  </mat-expansion-panel>
  <div class="cf-flex-row cf-justify-content-center cf-align-items-center" *ngIf="componentTypes.length > 0">
    <form [formGroup]="addComponentForm" class="flex-90-percent cf-flex-column">
      <mat-form-field>
        <mat-label>Add component</mat-label>
        <mat-select formControlName="componentType">
          <mat-option *ngFor="let componentType of componentTypes" [value]="componentType">
            {{ componentType }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </div>
</mat-accordion>
